import React, { useEffect, useState } from "react";
import api from '../../api/axiosInstance';
import { Card, Form, Button, Alert } from "react-bootstrap";
import { useParams } from "react-router-dom";
import AdminLayout from "../../components/admin/AdminLayout";
import QuillEditor from "../../components/QuillEditor";

const EditBlogPage = () => {
  const { id } = useParams();
  const token = localStorage.getItem("token");

  const [title, setTitle] = useState("");
  const [imageUrl, setImageUrl] = useState("");
  const [content, setContent] = useState("");
  const [message, setMessage] = useState(null);

  const loadBlog = async () => {
    const res = await api.get(`/blogs/${id}`);
    setTitle(res.data.title);
    setImageUrl(res.data.imageUrl || "");
    setContent(res.data.content);
  };

  useEffect(() => {
    loadBlog();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.put(
        `/blogs/${id}`,
        { title, content, imageUrl },
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setMessage({ type: "success", text: "Blog güncellendi!" });
    } catch (err) {
      setMessage({
        type: "danger",
        text: err.response?.data?.message || "Hata oluştu.",
      });
    }
  };

  return (
    <AdminLayout>
      <Card className="p-4 shadow-sm" style={{ maxWidth: "900px", margin: "0 auto" }}>
        <h3 className="text-center mb-4" style={{ color: "#2D8A7A" }}>
          Blog Düzenle
        </h3>

        {message && <Alert variant={message.type}>{message.text}</Alert>}

        <Form onSubmit={handleSubmit}>
          <Form.Group className="mb-3">
            <Form.Label>Başlık</Form.Label>
            <Form.Control value={title} onChange={(e) => setTitle(e.target.value)} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Resim URL</Form.Label>
            <Form.Control value={imageUrl} onChange={(e) => setImageUrl(e.target.value)} />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>İçerik</Form.Label>
            <QuillEditor value={content} onChange={setContent} />
          </Form.Group>

          <Button type="submit" className="btn-primary w-100 mt-3">
            Kaydet
          </Button>
        </Form>
      </Card>
    </AdminLayout>
  );
};

export default EditBlogPage;
